import { asset } from '../../../../../../shared/frontend/services/assetResolverService';
import _ from 'lodash';
import { SimpleTooltip } from '../../../../../../shared/frontend/components/presentational/tooltip';

export function CorruptionDetailsTooltip(props: any) {
  const { corruption } = props;

  const corruptionSpells = _.get(corruption, 'spells', []);
  corruptionSpells.sort((a: any, b: any) => {
    if (a.name === b.name) {
      return 0;
    } else if (a.name < b.name) {
      return -1;
    } else {
      return 1;
    }
  });

  if (!corruptionSpells.length) {
    return <div className="slds-text-align--center text-muted">-</div>;
  }

  return (
    <SimpleTooltip
      tooltip={
        <div className="slds-text-align--center">
          {corruption.resisted === 0 ? (
            <div>No Corruption Resistance</div>
          ) : (
            <div>
              <b>{corruption.total}</b> Total Corruption
            </div>
          )}

          <div className="slds-text-align--left">
            {corruptionSpells.map((spell: any, index: number) => (
              <div className="slds-m-vertical--x-small">
                <span
                  key={index}
                  className="slds-avatar slds-avatar--small rio-border--light rio-shadow--small slds-m-horizontal--xx-small"
                >
                  <img src={asset(`/images/wow/icons/medium/${spell.icon}.jpg`)} width={36} height={36} />
                </span>{' '}
                {spell.name}
              </div>
            ))}
          </div>
        </div>
      }
      placement="top"
    >
      <img src={asset('/images/site/corruption_icon.png')} width={23} />
    </SimpleTooltip>
  );
}
